import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GlobalService } from './global.service';
import { environment } from 'src/environments/environment';//<<-files here contain API URLS for development vs production builds (see comments below); API urls *were* in settings.json before

@Injectable({
  providedIn: 'root'
})
export class RequestServices {
  constructor(
    private http: HttpClient,
    private global: GlobalService
  ) { }
  
  public postRequest(url, body): Observable<any> {
  
  //This change made to support angular.json "--configuration production/development" command line builds (removed API url from settings.json)
    //return this.http.post(this.global.settings.API_URL + url, body); <<-"API_URL" *was* in settings.json
	return this.http.post(environment.apiUrl + url, body);
  }
  
    
  
  
  public getRequest(URL: any): Observable<any> {
    //return this.http.get(this.global.settings.API_URL + URL);//<<------------------see above comments for change details
	return this.http.get(environment.apiUrl + URL); 
  }
}

